import { Component, OnInit } from '@angular/core';
import {
	FlashProductGroup, 
	EditFlashProductGroupModel 
} from '../../../models/inModels/Flash';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { NotificationContentType } from '../../../models/inModels/MessageModel';
import { Router } from '@angular/router';
import { FlashService } from '../../../services/flash/flash.service';
import { DataTable } from 'primeng/components/datatable/datatable';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-flash-product-group',
  templateUrl: './flash-product-group.component.html'
})
export class FlashProductGroupComponent implements OnInit {
  	items: FlashProductGroup[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	displayDialog: boolean = false;
	selectedFlashProductGroup: FlashProductGroup;
  constructor(
    private service: FlashService,
		private router: Router,
		private confirmationService: ConfirmationService,
		public storageService: StorageService,
  ) {
    this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
   }

  ngOnInit() {
	
  }
  changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

  load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.searchGroup(event).then(
			dataPager => {
			this.items = dataPager.Data;
			this.filteredRecords = dataPager.FilteredRecords;
			this.totalRecords = dataPager.TotalRecords;
        	this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
  }

  delete(event: FlashProductGroup) {
		console.log(event);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${event.Name}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.deleteGroup(event.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
  }
  
	edit(item: FlashProductGroup) {
		this.router.navigate(['flash/groups/edit', item.Id]);
	}

	openModal(item: FlashProductGroup) {
		this.displayDialog = true;
		this.selectedFlashProductGroup = item;

		console.log(this.selectedFlashProductGroup)
	}
  
}



// WEBPACK FOOTER //
// ./src/app/components/flash/groups/flash-product-group.component.ts